// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ImageWithCaption } from '../../ImageWithCaption';
import { BootstrapImage } from '../../../../dsl/bootstrap';
import NoSSR from 'vue-no-ssr';
import VueEasyLightbox from 'vue-easy-lightbox';
let ArticleHeaderImage = class ArticleHeaderImage extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the image is displayed in fullscreen mode
         */
        this.isFullScreenPreviewOpen = false;
    }
    /**
     * Checking that content has a cover photo - Thumbnail
     */
    get hasThumbnail() {
        return !!this.thumbnail;
    }
    get hasVideo() {
        return this.$slots.video !== undefined && this.$slots.video.length > 0;
    }
    /**
     * Closes fullscreen view of the image
     */
    closeFullScreenPreview() {
        this.isFullScreenPreviewOpen = false;
    }
    /**
     * Opens image in the fullscreen mode
     */
    openFullScreenPreview() {
        this.isFullScreenPreviewOpen = true;
    }
};
__decorate([
    Prop({ type: String, required: false, default: '' })
], ArticleHeaderImage.prototype, "fallbackImage", void 0);
__decorate([
    Prop({ type: String, required: false })
], ArticleHeaderImage.prototype, "caption", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleHeaderImage.prototype, "hideDescription", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleHeaderImage.prototype, "isLazy", void 0);
__decorate([
    Prop({ type: Object, required: false, default: null })
], ArticleHeaderImage.prototype, "thumbnail", void 0);
ArticleHeaderImage = __decorate([
    Component({
        name: 'ArticleHeaderImage',
        components: {
            BootstrapImage,
            ImageWithCaption,
            NoSSR,
            VueEasyLightbox
        },
        template: `
    <div class="article-header__image">
      <template v-if="hasThumbnail">
        <ImageWithCaption
          v-if="thumbnail"
          :image="thumbnail"
          :hideDescription="hideDescription"
          :overridenCaption="caption"
          :isLazy="isLazy"
          :fetchPriority="!isLazy"
          @click="openFullScreenPreview"
        >
          <slot name="video" />

          <slot name="ad" />
        </ImageWithCaption>
      </template>
      <template v-else>
        <BootstrapImage :src="fallbackImage" />

        <slot name="video" />

        <slot name="ad" />
      </template>

      <NoSSR>
        <VueEasyLightbox
          v-if="!hasVideo && thumbnail"
          :visible="isFullScreenPreviewOpen"
          :imgs="thumbnail.fullscreen"
          @hide="closeFullScreenPreview"
        />
      </NoSSR>
    </div>
  `
    })
], ArticleHeaderImage);
export { ArticleHeaderImage };
